import React from 'react'

export const EventDetailsPage = () => {
    return (
        <div>EventDetailsPage</div>
    )
}
